import { useState } from "react";
import { _CreditAccount, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { ImportXLSX } from "../../../../theme/Component/ImportXLSX";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { BasicButton } from "../../../../theme/Component/BasicButton";

export const ImportarSolicitudes=()=>{

    const _credit = useDataBean(_CreditAccount);
    const { bean, setBean, lista, setLista, handleChange } = _credit;
    const [data,setData] = useState<any>('');

    const importarComiteCredito=()=>{
        _credit.instance.importarComiteCredito(_single.getAccountID(),JSON.stringify(data)).then(
            (resp:any)=>{
                setLista(resp);
            }
        )
    }
    return(
        <div className="row">
            <div className="col">
                      <ImportXLSX lodaData={setData}/>
            </div>
            <div className="col-md-12">
                <BasicButton icon="" eventClick={importarComiteCredito}>Cargar</BasicButton>
            </div>
            <div className="col-md-12">
                Registros Importados {lista.length}
                
            </div>
        </div>
    )
}